// ✅ FILE: services/ticketThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../config/api";

export const submitNewTicket = createAsyncThunk(
    "tickets/submitNewTicket",
    async ({ token, payload }) => {
        const response = await api.post("/tickets/createTicket", payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data;
    }
);



// (Optional) Fetch current user's submitted tickets
export const fetchUserTickets = createAsyncThunk(
    "tickets/fetchUserTickets",
    async () => {
        const response = await api.get("/tickets/my-tickets");
        return response.data;
    }
);